import { FC } from 'react';
import { formatConfidence } from 'utils/number';
import type { WellConfidenceFactor } from './types';
import styles from './structuring-module.module.scss';

// Ported from the mock's per-tile score table + `PartyConfidenceBreakdownTable`.
// Renders the 6 weighted factors the backend persists in `confidenceFactors`.
// Backend sends weight/score as 0–1 fractions; we present them as percentages.

interface Props {
  factors: WellConfidenceFactor[];
}

export const WellConfidenceBreakdownTable: FC<Props> = ({ factors }) => (
  <table className={styles.scoreTable}>
    <thead>
      <tr>
        <th>Factor</th>
        <th>Weight</th>
        <th>Score</th>
      </tr>
    </thead>
    <tbody>
      {factors.map((row) => (
        <tr key={row.factor}>
          <td>{row.factor}</td>
          <td>{formatConfidence(row.weight)}</td>
          <td>{formatConfidence(row.score)}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
